import { Property } from '@/types/property';

export const FEATURED_PROPERTIES: Property[] = [
  {
    id: "1",
    title: "Villa en Margarita",
    description: "Hermosa villa con vista al mar en Margarita",
    location: {
      address: "Villa en Margarita",
      city: "Margarita",
      state: "Nueva Esparta",
      country: "venezuela",
      coordinates: { lat: 10.9577, lng: -63.8370 }
    },
    price: 250000,
    operationType: "venta",
    propertyType: "casa",
    images: ["https://images.unsplash.com/photo-1499793983690-e29da59ef1c2"],
    beds: 3,
    baths: 2,
    sqft: 150,
    type: "sale",
    bedrooms: 3,
    bathrooms: 2,
    area: 150,
    features: ["Piscina", "Vista al mar", "Seguridad 24/7"],
    estacionamientos: 2,
    antiguedad: 5,
    condition: "Excelente",
    orientation: "Norte",
    yearBuilt: 2018,
    areaUtil: 150,
    areaTerreno: 300,
    zonasComunes: ["Piscina", "Área social"],
    services: ["Agua", "Electricidad", "Gas"],
    amoblado: false
  },
  {
    id: "2",
    title: "Apartamento en Bogotá",
    description: "Moderno apartamento en zona exclusiva",
    location: {
      address: "Apartamento en Bogotá",
      city: "Bogotá",
      state: "Cundinamarca",
      country: "colombia",
      coordinates: { lat: 4.7110, lng: -74.0721 }
    },
    price: 180000,
    operationType: "arriendo",
    propertyType: "apartamento",
    images: ["https://images.unsplash.com/photo-1545324418-cc1a3fa10c00"],
    beds: 3,
    baths: 2,
    sqft: 150,
    type: "rent",
    bedrooms: 3,
    bathrooms: 2,
    area: 150,
    features: ["Vista a la ciudad", "Gimnasio", "Área social"],
    estacionamientos: 2,
    antiguedad: 3,
    condition: "Excelente",
    orientation: "Este",
    yearBuilt: 2020,
    areaUtil: 150,
    areaTerreno: 150,
    zonasComunes: ["Gimnasio", "Área social"],
    services: ["Agua", "Electricidad", "Gas"],
    amoblado: true
  },
  {
    id: "3",
    title: "Casa en Lima",
    description: "Espaciosa casa en Miraflores",
    location: {
      address: "Casa en Miraflores", 
      city: "Lima",
      state: "Lima",
      country: "peru",
      coordinates: { lat: -12.0464, lng: -77.0428 }
    },
    price: 220000,
    operationType: "venta",
    propertyType: "casa",
    images: ["https://images.unsplash.com/photo-1512917774080-9991f1c4c750"],
    beds: 3,
    baths: 2,
    sqft: 150,
    type: "sale",
    bedrooms: 3,
    bathrooms: 2,
    area: 150,
    features: ["Piscina", "Jardín", "Terraza"],
    estacionamientos: 2,
    antiguedad: 8,
    condition: "Bueno",
    orientation: "Oeste",
    yearBuilt: 2015,
    areaUtil: 150,
    areaTerreno: 400,
    zonasComunes: ["Piscina", "Jardín"],
    services: ["Agua", "Electricidad", "Gas"],
    amoblado: false
  },
  {
    id: "4",
    title: "Departamento en Buenos Aires",
    description: "Lujoso departamento en Palermo",
    location: {
      address: "Departamento en Palermo",
      city: "Buenos Aires",
      state: "Buenos Aires",
      country: "argentina",
      coordinates: { lat: -34.6037, lng: -58.3816 }
    },
    price: 195000,
    operationType: "temporal",
    propertyType: "apartamento",
    images: ["https://images.unsplash.com/photo-1518780664697-55e3ad937233"],
    beds: 3,
    baths: 2,
    sqft: 150,
    type: "temporal",
    bedrooms: 3,
    bathrooms: 2,
    area: 150,
    features: ["Vista a la ciudad", "Piscina", "Seguridad privada"],
    estacionamientos: 2,
    antiguedad: 2,
    condition: "A estrenar",
    orientation: "Norte",
    yearBuilt: 2021,
    areaUtil: 150,
    areaTerreno: 350,
    zonasComunes: ["Piscina", "Área social"],
    services: ["Agua", "Electricidad", "Gas"],
    amoblado: false
  }
];

// Alias para mantener compatibilidad con código existente
export const BEACH_PROPERTIES = FEATURED_PROPERTIES;
